import Vue from 'vue'
import uiKitPlugin from '@invivodf/ui-kit'
import { installCommonCustomValidateRules } from '@invivodf/common/src/infrastructure/rules/custom-common-rules.validate'
import StaticLabels from '@/retail/application/plugins/static-labels'
import installRetailCustomValidateRules from '@/retail/application/plugins/custom-rules.validate'
import { bootstrapRetailAuth } from '@/auth/bootstrapAuth-retail'
import { registerCommonPlugins, mountApp } from './main-shared'

function registerRetailPlugins(): void {
  Vue.use(StaticLabels)
  Vue.use(uiKitPlugin as any, {
    preloadAllComponents: false,
    environmentName: window.env.ENVIRONMENT_NAME,
    cloudinaryBucketName: window.env.CLOUDINARY_BUCKET_NAME,
    themeName: process.env.VUE_APP_DS_THEME_NAME,
  })

  // vee-validate v3 — retail rules then the common ones (common wins on collision)
  installRetailCustomValidateRules()
  installCommonCustomValidateRules()
}

export function startRetailApp(): void {
  registerCommonPlugins()
  registerRetailPlugins()

  // @ts-expect-error : XJU à typer plus tard
  window.globalStore = {}

  bootstrapRetailAuth()
  mountApp()
}
